import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "Context/AuthContext";

import Login from 'Pages/Login/Login'// Layout
import AdminLayout from "Layouts/AdminLayout";
import ProtectedRoute from "Components/ProtectedRoute";

// Pages
import Appointment from "Pages/Appointment/Appointment";
import VehicleRecord from "Pages/Vehicle/VehicleRecord";
import VehicleMaintenanceRecord from 'Pages/Vehicle/VehicleMaintenanceRecord';
import Services from 'Pages/Services/Services'
import QuoteRequest from 'Pages/Quote/QuoteRequest'

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Appointment />} />
            <Route path="appointment" element={<Appointment />} />
            {/* <Route path="clients" element={<ClientRecord />} /> */}
            <Route path="vehicles" element={<VehicleRecord />} />
            <Route path="services" element={<Services />} />
            <Route path="quotes" element={<QuoteRequest />} />
          </Route>
          <Route
            path="/vehicle-maintenance-record"
            element={
              <ProtectedRoute>
                <VehicleMaintenanceRecord />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
